var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHappy(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.0002 24.6668C19.8912 24.6668 24.6668 19.8912 24.6668 14.0002C24.6668 8.10914 19.8912 3.3335 14.0002 3.3335C8.10913 3.3335 3.3335 8.10914 3.3335 14.0002C3.3335 19.8912 8.10913 24.6668 14.0002 24.6668Z",
    fill: "url(#paint0_radial_1414_3937)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M14.0002 24.6668C19.8912 24.6668 24.6668 19.8912 24.6668 14.0002C24.6668 8.10914 19.8912 3.3335 14.0002 3.3335C8.10913 3.3335 3.3335 8.10914 3.3335 14.0002C3.3335 19.8912 8.10913 24.6668 14.0002 24.6668Z",
    fill: "url(#paint1_radial_1414_3937)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6535 8.4731C11.6535 8.04645 11.1935 7.77979 10.3935 7.77979C9.72015 7.77979 8.23349 8.1531 7.21349 9.46644C7.02683 9.70643 7.31348 9.83978 7.50014 9.68645C8.12681 9.15312 9.8135 8.46645 11.1268 8.6131C11.6535 8.66644 11.6535 8.4731 11.6535 8.4731Z",
    fill: "url(#paint2_linear_1414_3937)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5136 13.6535C11.0806 13.6535 11.5403 12.9581 11.5403 12.1002C11.5403 11.2423 11.0806 10.5469 10.5136 10.5469C9.94659 10.5469 9.48694 11.2423 9.48694 12.1002C9.48694 12.9581 9.94659 13.6535 10.5136 13.6535Z",
    fill: "url(#paint3_radial_1414_3937)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5136 11.0732C10.9536 11.0732 11.3403 11.4598 11.5403 12.0265C11.5269 11.1865 11.0736 10.5132 10.5136 10.5132C9.95359 10.5132 9.50027 11.1865 9.48694 12.0265C9.68693 11.4598 10.0736 11.0732 10.5136 11.0732Z",
    fill: "url(#paint4_linear_1414_3937)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3468 8.4731C16.3468 8.04645 16.8068 7.77979 17.6068 7.77979C18.2802 7.77979 19.7668 8.1531 20.7868 9.46644C20.9735 9.70643 20.6868 9.83978 20.5001 9.68645C19.8735 9.15312 18.1868 8.46645 16.8735 8.6131C16.3402 8.66644 16.3468 8.4731 16.3468 8.4731Z",
    fill: "url(#paint5_linear_1414_3937)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7135 17.1201C18.6268 17.1067 18.5335 17.1334 18.4735 17.1934C17.3268 18.2667 15.5601 18.8467 14.2268 18.8467H14.0001H13.7735C12.4402 18.8467 10.6735 18.2667 9.52679 17.1934C9.46015 17.1334 9.37349 17.1067 9.2868 17.1201C9.19349 17.14 9.1468 17.24 9.19349 17.3201C10.1735 19.0134 11.9802 20.0601 13.9468 20.0601H14.0068H14.0668C16.0335 20.0601 17.8401 19.0134 18.8201 17.3201C18.8535 17.24 18.8068 17.14 18.7135 17.1201Z",
    fill: "#643800"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4801 13.6535C18.0471 13.6535 18.5067 12.9581 18.5067 12.1002C18.5067 11.2423 18.0471 10.5469 17.4801 10.5469C16.913 10.5469 16.4534 11.2423 16.4534 12.1002C16.4534 12.9581 16.913 13.6535 17.4801 13.6535Z",
    fill: "url(#paint6_radial_1414_3937)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4801 11.0732C17.04 11.0732 16.6534 11.4599 16.4534 12.0265C16.4667 11.1865 16.9201 10.5132 17.4801 10.5132C18.0401 10.5132 18.4934 11.1865 18.5067 12.0265C18.3067 11.4599 17.92 11.0732 17.4801 11.0732Z",
    fill: "url(#paint7_linear_1414_3937)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7135 17.1201C18.6268 17.1067 18.5335 17.1334 18.4735 17.1934C17.3268 18.2667 15.5601 18.8467 14.2268 18.8467H14.0001H13.7735C12.4402 18.8467 10.6735 18.2667 9.52679 17.1934C9.46015 17.1334 9.37349 17.1067 9.2868 17.1201C9.19349 17.14 9.1468 17.24 9.19349 17.3201C9.20014 17.34 9.21347 17.3534 9.22681 17.3667C9.32015 17.3134 9.42015 17.2601 9.52014 17.3734C10.6068 18.5934 12.2201 19.3267 13.9468 19.3267H14.0068H14.0668C15.8068 19.3267 17.4268 18.5867 18.5135 17.3467C18.6135 17.2334 18.7068 17.2867 18.7935 17.3467C18.8002 17.3334 18.8068 17.3267 18.8135 17.3134C18.8535 17.24 18.8068 17.14 18.7135 17.1201Z",
    fill: "url(#paint8_linear_1414_3937)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_1414_3937",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(11.8988 9.67732) scale(12.868 12.868)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE030"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB92E"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_1414_3937",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(11.8988 9.67731) scale(10.1238 10.1238)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEA5F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBC47",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1414_3937",
    x1: 9.40158,
    y1: 9.18805,
    x2: 9.40158,
    y2: 8.06409,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00132565,
    stopColor: "#3C2200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7A4400"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_1414_3937",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(10.207 12.1443) rotate(73.8539) scale(1.50712 0.975086)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00132565,
    stopColor: "#7A4400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#643800"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1414_3937",
    x1: 10.5151,
    y1: 10.5405,
    x2: 10.5151,
    y2: 11.9881,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00132565,
    stopColor: "#3C2200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#512D00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1414_3937",
    x1: 18.5935,
    y1: 9.18805,
    x2: 18.5935,
    y2: 8.06409,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00132565,
    stopColor: "#3C2200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7A4400"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_1414_3937",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(17.1722 12.1445) rotate(73.8539) scale(1.50712 0.975087)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00132565,
    stopColor: "#7A4400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#643800"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1414_3937",
    x1: 17.4799,
    y1: 10.5405,
    x2: 17.4799,
    y2: 11.9882,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00132565,
    stopColor: "#3C2200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#512D00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1414_3937",
    x1: 13.9975,
    y1: 17.874,
    x2: 13.9975,
    y2: 19.4664,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00132565,
    stopColor: "#3C2200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#512D00"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHappy);
export default __webpack_public_path__ + "static/media/Happy.c6ebb0060c94d101f2303a8f177dd284.svg";
export { ForwardRef as ReactComponent };